{
  "nav": {
    "pricing": "Cennik",
    "contact": "Kontakt",
    "menu": "Menu",
    "login": "Zaloguj się",
    "features": "Funkcje",
    "brandHomeAria": "Done-it — strona główna",
    "market": {
      "belgium": "Belgia",
      "international": "Cały świat"
    }
  },
  "footer": {
    "tagline": "Done-it — Prosta ewidencja czasu pracy.",
    "terms": "Regulamin",
    "privacy": "Prywatność",
    "contact": "Kontakt"
  },
  "help": "Potrzebujesz pomocy?",
  "continue": "Dalej",
  "back": "Wstecz",
  "change": "Zmień",
  "retry": "Spróbuj ponownie",
  "errors": {
    "unexpected": "Nieoczekiwany błąd"
  },
  "step": {
    "of": "Krok {{n}} z {{total}}"
  },
  "funnel": {
    "title": "Subskrypcja · Done-it"
  }
}
